import { useSelector } from "@tanstack/react-form";
import { format } from "date-fns";
import { isValidDate } from "../../../utils/date";
import {
	DatePicker,
	DatePickerStandalone,
	type IDatepPicker,
	type ReactDatePickerStandaloneProps,
} from "../../form-fields/datepicker";
import { Stack } from "../../stack";
import { useFieldContext } from "../form/form-context";
import { FieldInfo } from "./fieldinfo";

type TextFieldProps = {
	label: string;
} & Omit<IDatepPicker, "onChange" | "name">;

export const DatePickerField = ({ label, ...rest }: TextFieldProps) => {
	const field = useFieldContext<string>();
	const meta = useSelector(field.store, (state) => state.meta);

	const onChange = (value: string | null) => {
		if (value) {
			field.handleChange(value);
		} else {
			field.handleChange("");
		}
	};
	return (
		<Stack gap={2}>
			<DatePicker
				name={field.name}
				label={label}
				value={field.state.value}
				onChange={onChange}
				error={meta.errors.length > 0}
				{...rest}
			/>
			<FieldInfo field={field} />
		</Stack>
	);
};

export const DatePickerStandaloneField = ({ ...rest }: ReactDatePickerStandaloneProps) => {
	const field = useFieldContext<string>();
	const value = field.state.value;
	const onSelect = (value: Date | null) => {
		if (value) {
			field.handleChange(format(value, "yyyy-MM-dd"));
		} else {
			field.handleChange("");
		}
	};

	return (
		<Stack gap={2}>
			<DatePickerStandalone
				name={field.name}
				value={field.state.value}
				onSelect={onSelect}
				selected={value && isValidDate(value) ? new Date(value) : undefined}
				{...rest}
			/>
			<FieldInfo field={field} />
		</Stack>
	);
};
